import { FC } from 'react';
import { BuilderFieldLabel, BuilderFieldLabelProps } from '../../wrappers/label/builderFieldLabel.component';
import { BuilderFieldError, BuilderFieldErrorProps } from '../../wrappers/error/builderFieldError.component';
import { AppSliderInputProps } from 'uikit/inputs/slider/appSliderInput';
import { AppSliderInput } from 'uikit/inputs';

export type AppSliderFieldType = {
  labelProps: BuilderFieldLabelProps;
  errorProps?: BuilderFieldErrorProps;
} & AppSliderInputProps;

export const AppSliderField: FC<AppSliderFieldType> = ({ errorProps, labelProps, disabled, value, ...rest }) => {
  return (
    <BuilderFieldError {...errorProps}>
      <BuilderFieldLabel disabled={disabled} {...labelProps}>
        <AppSliderInput disabled={disabled} value={value} {...rest} />
      </BuilderFieldLabel>
    </BuilderFieldError>
  );
};
